import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { LogService } from '../../../../core/services/log.service';

import AccessControlPageView from "./access-control.page.html";
import { EventsService } from '../../services/events.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
@Component({
  selector: 'event-access-control-page',
  template: AccessControlPageView
})
export class AccessControlPage implements OnInit {

  dateSelected: string = '';
  isAllowed: boolean = false;
  guestAccessesByStatus: number[] = [];
  eventId: number;
  timezone: string = null;

  constructor(@Inject(AuthService) private authService: AuthService,
              @Inject(LogService) private log: LogService,
              @Inject('$stateParams') private $stateParams: any,
              @Inject(EventsService) private eventsService: EventsService) { 
    this.eventId = this.$stateParams.id;
    this.loadEvent();
  }

  private async loadEvent() {
    let event = await firstValueFrom(this.eventsService.getEvent(this.eventId));
    if (event) {
      this.timezone = event.timezone;
    }
  }
  
  ngOnInit() {
    this.log.debug('AccessControlPage');
    this.isAllowed = this.authService.permissionExist('RESUME_REPORT_READ') ?? false;
    this.eventId = this.$stateParams.id;
  }

  onDateSelect(event: string) {
    this.dateSelected = event;
  }

}
